const GET_EQUIPMENT_TYPE = 'GET_EQUIPMENT_TYPE';
const SAVE_EQUIPMENT_TYPE = 'SAVE_EQUIPMENT_TYPE';

export
{
    GET_EQUIPMENT_TYPE,
    SAVE_EQUIPMENT_TYPE
};